// @flow
import { GA_DEFAULT_PAYLOAD } from 'Tracking/constants';
import { setDataLayer } from 'Tracking/tracking-api';

export const CHATBOT_EVENTS = {
  INITIALIZED: 'chatbot-initialized',
  CLICKED_OPEN: 'chatbot-opened',
  CLICKED_CLOSE: 'chatbot-closed',
};

export const trackChatbotEvent = (
  chatbotEventType: string,
  appContext: AppContext,
  pageContext: PageContext,
  location: RouterLocation<>,
): void => {
  const { pageId } = pageContext;
  return setDataLayer(
    {
      ...GA_DEFAULT_PAYLOAD,
      categoryGA: 'chatbot',
      actionGA: chatbotEventType,
      labelGA: pageId || location.origin || 'unknown-context',
    },
    appContext,
    pageId,
  );
};
